import { IUpdateManutencaoUseCase } from "../../../presentation/useCases/update/update_manutencao_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateManutencaoUseCase
 */

export class UpdateManutencaoUseCase implements IUpdateManutencaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idManutencao: number,
    status: string,
    idCentroCusto?: number,
    idFuncionarioAprovacao?: number,
    dataPrevConclusao?: Date,
    dataConclusao?: Date,
    dataAprovacao?: Date,
    observacao?: string,
    idMaquinaEquip?: number,
    idFuncionarioSolicitante?: number,
    idFornecedorResponsavel?: number,
    valorOrcamento?: number,
    descricao?: string,
    dataSolicitacao?: Date,
    idFuncionarioResponsavel?: number,
    tipoManutencao?: number,
    motivoReprovacao?: string,
    nomeArquivo1?: string | null,
    nomeArquivo2?: string | null,
    nomeArquivo3?: string | null,
    arquivo1?: File | null,
    arquivo2?: File | null,
    arquivo3?: File | null,
    limparArquivo1?: boolean,
    limparArquivo2?: boolean,
    limparArquivo3?: boolean
  ): Promise<void> {
    await this.repository.updateManutencao(
      idManutencao,
      status,
      idCentroCusto,
      idFuncionarioAprovacao,
      dataPrevConclusao,
      dataConclusao,
      dataAprovacao,
      observacao,
      idMaquinaEquip,
      idFuncionarioSolicitante,
      idFornecedorResponsavel,
      valorOrcamento,
      descricao,
      dataSolicitacao,
      idFuncionarioResponsavel,
      tipoManutencao,
      motivoReprovacao,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      arquivo1,
      arquivo2,
      arquivo3,
      limparArquivo1,
      limparArquivo2,
      limparArquivo3
    );
  }
}
